import React, { Component } from 'react';
import DatePicker from 'react-date-picker';
import TodoTable from "./TodoTable";

const baseURL = "/api/tasks/";

class Todolist extends Component {
    constructor(props) {
        super(props);
        this.state = {description: '', todos: [], date: new Date(), loading: true, descTooLong: false}
      }

      inputChanged = (formName, event) => {
          if (formName === 'description') {
              this.setState({[formName]: event.target.value});
              if (event.target.value.length > 120) {
                this.setState({descTooLong: true})
              } else {
                this.setState({descTooLong: false})
              }
          } else if (formName === 'date' && event != null) {
              this.setState({[formName]: event});
          } 
      }

      addTodo = (event) => {
        event.preventDefault();
        if (this.state.description.length > 0) {
            const myObject = { description: this.state.description, date: this.state.date.toLocaleDateString('fi-FI') };
            this.setState({
              description: '',
              date: new Date()
            });
            fetch(baseURL, {
			  method: 'POST',
			  headers: {
				'Content-Type': 'application/json',
			  },
			  body: JSON.stringify(myObject)
		    }).then((response) => response.json())
		      .then((responseData) => {
				  this.updateList();
			});
        }
      }

      buttonPressed = (event) => {
          fetch(baseURL + event.target.name, {
			  method: 'DELETE'
		    }).then((response) => response.json())
		      .then((responseData) => {
				  this.updateList();
			});
      }
      
      componentDidMount() {
	      this.updateList();
	  }
	  
	  componentDidUpdate(prevProps, prevState) {
        if (this.state.todos !== prevState.todos) {
            this.setState({
                loading: false
            });
        }
    }
	
      updateList() {
		  this.setState({
			loading: true
		  });
		  fetch(baseURL)
		  .then((response) => response.json())
		  .then((responseData) => {
			  this.setState({
				  todos: responseData
			  });
		   });
	  }

      render() {
        return (
          <div class="w3-container w3-padding-large">
            <h2>Todolist</h2>
              <form class="todoform" onSubmit={this.addTodo}>
                <label>Pick date: </label>
                <DatePicker clearIcon={null} calendarIcon={null} locale="fi-FI" value={this.state.date} onChange={(e) => this.inputChanged("date",e)} />
                <input autoFocus placeholder="Description" class="w3-input w3-section w3-round" type="text" onChange={(e) => this.inputChanged("description",e)} value={this.state.description}/>
                {this.state.descTooLong && <div class="w3-panel w3-yellow w3-card-4 w3-animate-left">The description is too long!</div>}
                <input class="w3-input w3-section w3-btn w3-green" type="submit" value="Add" disabled={this.state.descTooLong} />
              </form>
              <TodoTable todos={this.state.todos} btn={this.buttonPressed} loading={this.state.loading} />
          </div>
        );
    }
}

export default Todolist;



// WEBPACK FOOTER //
// ./src/Todolist.js